import React from "react";
import { motion } from "framer-motion";

const analyticsData = [
  { title: "2,000", text: "Plus active traders in month one", gradient: "from-[#F458FF]/25 to-black" },
  { title: "1,000,000+", text: "MON traded", gradient: "from-white/25 to-black" },
  { title: "99.8%", text: "Successful swaps", gradient: "from-[#F458FF]/25 to-black"},
  { title: ">1 SEC", text: "Average routing time", gradient: "from-white/25 to-black" },
  { title: "0", text: "Rug incidents reported", gradient: "from-white/25 to-black" },
];

const Analytics = () => {
  return (
    <section className="w-full px-4 sm:px-6 md:px-8 py-36 sm:py-24 md:py-48 lg:py-64 text-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-center mb-12">
          ANALYTICS REPORT
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {analyticsData.slice(0,3).map((card, index) => (
            <motion.div
              key={index}
              className={`p-6 rounded-xl flex flex-col items-center justify-center text-center bg-gradient-to-b ${card.gradient}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
            >
              <h3 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-2">{card.title}</h3>
              <p className="text-sm sm:text-base md:text-lg">{card.text}</p>
            </motion.div>
          ))}
        </div>
        <div className="flex justify-center mt-6 gap-6">
          {analyticsData.slice(3).map((card, index) => (
            <motion.div
              key={index+3}
              className={`p-6 rounded-xl flex flex-col items-center justify-center text-center bg-gradient-to-b ${card.gradient}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: (index + 3) * 0.2 }}
            >
              <h3 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-2">{card.title}</h3>
              <p className="text-sm sm:text-base md:text-lg">{card.text}</p>
            </motion.div>
          ))}
        </div>

        <h3 className="text-xl sm:text-2xl md:text-4xl font-semibold text-center mt-12">
          Built fast. Built secure. Built to last.
        </h3>
      </div>
    </section>
  );
};

export default Analytics;
